(function () {


function render_blogs_list () {
  const blogs_list = document.querySelector('.shopify-section--main-blog');
  if (!blogs_list) return;
  
  const h1 = document.querySelector('.h2');
  if (h1) {
    const words = h1.textContent.trim().split(/\s+/);
    if (words.length < 3) return;

    const new_html = `
      <span class="light">${words[0]} ${words[1]}</span> <span class="bold">${words.slice(2).join(' ')}</span>
    `;
    h1.innerHTML = new_html;
  }
}


function iterate_children(el, image_col) {
  for (let i=0; i<el.children.length; i++) {
    const child = el.children[i];
    if (child.tagName=='IMG') {
      image_col.appendChild(child);
      i--;
    } else {
      iterate_children(child, image_col);
    }
  }  
}


function render_blog () {
  const article = document.querySelector('.shopify-section--main-article .prose');
  if (!article) return;
  
  const article_row = document.createElement('div');
  article_row.className = 'article_row';

  const text_col = document.createElement('div');
  text_col.className = 'article_col text_col';
  article_row.appendChild(text_col);
  
  const new_article = article.cloneNode(true);
  new_article.classList.remove('prose');
  text_col.appendChild(new_article);
  
  const image_col = document.createElement('div');
  image_col.className = 'article_col image_col';
  article_row.appendChild(image_col);

  iterate_children(new_article, image_col);

  article.innerHTML = '';
  article.style.display = 'block';
  article.appendChild(article_row);
}


window.render_blogs_list = render_blogs_list;
window.render_blog = render_blog;


})()
